import { render, staticRenderFns } from "./OrgControls.vue?vue&type=template&id=408898de"
import script from "./OrgControls.vue?vue&type=script&lang=js"
export * from "./OrgControls.vue?vue&type=script&lang=js"
import style0 from "./OrgControls.vue?vue&type=style&index=0&id=408898de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports